/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

export type PriceLabel = {
    text?: string;
    className?: string;
}

export type Price = {
    title: string;
    labels: PriceLabel[];
};

const ONE_HOUR: PriceLabel = {text: '1 uur'}, HALF_HOUR: PriceLabel = {text: '30 minuten'},
    DOG_LABEL: PriceLabel = {text: 'Per hond'},
    defaultLabels: PriceLabel[] = [
        {text: 'Per hond', className: 'bold'},
        {text: 'Tarief', className: 'bold'},
        {text: 'Duur wandeling', className: 'bold'},
    ], FIRST_WALK: PriceLabel = {text: 'Proefwandeling (20% korting)', className: 'ul mt full'};

export const prices: Price[] = [
    {
        title: 'Groepswandeling',
        labels: [
            ...defaultLabels,
            DOG_LABEL,
            {text: '\u20ac 18,00'},
            ONE_HOUR,
            FIRST_WALK,
            DOG_LABEL,
            {text: '\u20ac 14,40'},
            ONE_HOUR,
        ]
    },
    // {
    //     title: 'Strippenkaart *',
    //     labels: [
    //         {text: 'Aantal strippen', className: 'bold'},
    //         {text: 'Tarief', className: 'bold'},
    //         {text: 'Geldigheid', className: 'bold'},
    //
    //         {text: '10 strippen'}, {text: '\u20ac 162,00'}, {text: '12 weken'},
    //         {text: '20 strippen'}, {text: '\u20ac 324,00'}, {text: '22 weken'},
    //
    //         {text: '* niet bruikbaar i.c.m. andere kortingen', className: 'mt full'},
    //     ]
    // },
]